/* eslint-disable import/no-extraneous-dependencies */

import Swiper from 'swiper';
import { Navigation, Scrollbar, A11y } from 'swiper/modules';
import { debounce, tabletViewMin, removeHiddenAssets } from './util';

const SWIPERID = '.js-contenttiles-slider';

const ContentTilesSlider = (() => {
    function handleSwiperContentTiles() {
        const mySwiper = undefined;

        const destroyParams = {
            cleanStyles: true,
        };

        function initSlider(currentSwiper, mySwiper, index) {
            const options = {
                // configure Swiper to use modules
                modules: [Navigation, Scrollbar, A11y],
                spaceBetween: 24,
                slidesPerView: 'auto',
                watchOverflow: true,
                breakpointsInverse: true,
                scrollbar: {
                    el: `.js-contenttiles-slider-scrollbar-${index}`,
                    draggable: true,
                },
                navigation: {
                    nextEl: `.js-contenttiles-slider-next-${index}`,
                    prevEl: `.js-contenttiles-slider-prev-${index}`,
                },
                a11y: {
                    prevSlideMessage: `${window.resources['slider.prev.slide.label']}`,
                    nextSlideMessage: `${window.resources['slider.next.slide.label']}`,
                    firstSlideMessage: `${window.resources['slider.first.slide.label']}`,
                    lastSlideMessage: `${window.resources['slider.last.slide.label']}`,
                },
            };

            if (typeof mySwiper === 'undefined') {
                $(currentSwiper).removeClass('contenttiles-slider-not-active');
                mySwiper = new Swiper(currentSwiper, options);
            }
        }

        function destroySlider(currentSwiper, mySwiper) {
            $(currentSwiper).addClass('contenttiles-slider-not-active');
            if (mySwiper) {
                mySwiper.destroy(destroyParams);
            }
        }

        function getSlidesWidth(currentSwiper) {
            const slideWidth = 320;
            let totalWidth = 0;
            let numberOfSlides;
            numberOfSlides = $(currentSwiper).find('.swiper-slide').length;
            totalWidth = parseInt(numberOfSlides * slideWidth, 10);
            return totalWidth;
        }

        $(SWIPERID).each(function (index) {
            const $this = $(this);
            $this.addClass(`js-contenttiles-slider-${index}`);
            const currentSwiper = `.js-contenttiles-slider-${index}`;

            if (!$this.length > 0) {
                return;
            }
            if (typeof mySwiper !== 'undefined') {
                destroySlider(currentSwiper, mySwiper);
            }
            removeHiddenAssets($this, '.swiper-slide');

            $(currentSwiper).parents('.contenttiles').find('.js-contenttiles-slider-scrollbar').addClass(`js-contenttiles-slider-scrollbar-${index}`);
            $(currentSwiper).parents('.contenttiles').find('.js-contenttiles-slider-next').addClass(`js-contenttiles-slider-next-${index}`);
            $(currentSwiper).parents('.contenttiles').find('.js-contenttiles-slider-prev').addClass(`js-contenttiles-slider-prev-${index}`);

            // options to enable/disable the slider on mobile & desktop
            if ($(currentSwiper).data('disable-slider-desktop') == true && $(currentSwiper).data('disable-slider-mobile') === true) {
                destroySlider(currentSwiper, mySwiper);
                $(currentSwiper).removeClass('contenttiles-slider-not-active').addClass('contenttiles__slider--grid');
            } else if ($(currentSwiper).data('disable-slider-desktop') === true && window.innerWidth > tabletViewMin) {
                destroySlider(currentSwiper, mySwiper);
                $(currentSwiper).removeClass('contenttiles-slider-not-active').addClass('contenttiles__slider--grid');
            } else if ($(currentSwiper).data('disable-slider-mobile') === true && window.innerWidth < tabletViewMin) {
                destroySlider(currentSwiper, mySwiper);
                $(currentSwiper).removeClass('contenttiles-slider-not-active').addClass('contenttiles__slider--grid');
            } else if ((getSlidesWidth(currentSwiper) > $(currentSwiper).width())) {
                // if the slides width is greater than its container width, slider is enabled
                initSlider(currentSwiper, mySwiper, index);
                $(currentSwiper).removeClass('contenttiles__slider--grid');
            } else {
                destroySlider(currentSwiper, mySwiper);
            }
        });
    }

    return {
        init() {
            handleSwiperContentTiles();
        },
        resize() {
            handleSwiperContentTiles();
        },
    };
})();

let windowWidth = $(window).width();

export default (() => {
    $(ContentTilesSlider.init);

    $(window).on('resize', debounce(() => {
        if ($(window).width() !== windowWidth) {
            windowWidth = $(window).width();
            ContentTilesSlider.resize();
        }
    }, 300));
})();
